import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, message, Button } from "antd";
import { Table, DEFAULT_PAGE_DATA } from "./../../../components/table";
import { generateTableColumns, generateQueryFormConfig, DEFAULT_QUERY_DATA } from "./config";
import { SettingsServer } from "./../../../server";
import { Operation } from "./operation";
import { langCommon } from "../../../locales";
import { EditForm } from "../../../components/editForm";

const server = SettingsServer.Banner

export const Banner = () => {
    const operationRef: any = useRef();

    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });
    const [options, setOptions] = useState<any>({
        positionOptions: [
            {id: 1, name: '首页'},
            {id: 2, name: '保险箱'},
            {id: 3, name: '个人中心'},
        ],
        statusOptions: [
            {id: 1, name: '有效'},
            {id: 2, name: '无效'},
        ],
        styleOptions: [            
            {id: 1, name: '白天版'},
            {id: 2, name: '黑夜版'},
        ],
    })

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });
    // 删除
    const { run: deleteData } = useRequest(server.delete, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onSuccess: () => {
            refresh();
            message.success(langCommon?.deleteSuccess);
        }
    });

    const getQueryFormConfig = useMemo(() => {
        return generateQueryFormConfig({ options });
    }, [options]);

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ deleteData, operationRef, loading, setLoading, refresh });
    }, [deleteData, operationRef, loading, setLoading, refresh]);

    return (
        <div>
            <Card>
                <div className="flex space-between">
                    <EditForm
                        componentId="banner-query-form"
                        loading={loading}
                        formAttrsProps={{
                            layout: 'inline',
                        }}
                        formData={queryData}
                        onDataChange={setQueryData}
                        formConfig={getQueryFormConfig}
                        onQuery={() => {
                            run({ ...DEFAULT_PAGE_DATA, ...queryData });
                        }}
                        onReset={() => {
                            setQueryData({ ...DEFAULT_QUERY_DATA });
                            run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                        }}
                    />
                    <Button className="ml10" type="primary" onClick={() => operationRef.current?.changeVisible(true, 'create')}>{langCommon?.create}</Button>
                </div>
            </Card>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...queryData });
                    }}
                />
            </Card >
            <Operation ref={operationRef} onSuccess={refresh} />
        </div>
    );
}